import { Client } from '@api/index'
import UserModal from '@assets/images/ambassdor/UserModal'
import { useAmbassadorContext } from '@context/context'
import { Dialog, Transition } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/solid'
import {
  Button,
  Checkbox,
  Dropdown,
  InputField,
  Typography,
} from '@pw-tech/omni-ui'
import { PROGRAM_TYPE } from '@utils/enum'
import React, { Fragment, useEffect, useState } from 'react'
import toast from 'react-hot-toast'

const UserRegistrationModal = ({
  isOpen,
  onClose,
  enteredUserData,
  selectedPlan,
}: {
  isOpen: boolean
  onClose: () => void
  enteredUserData?: any
  selectedPlan: any
}) => {
  console.log('enteredUserData', enteredUserData)
  const [email, setEmail] = useState(enteredUserData?.email || '')
  const [states, setStates] = useState([])
  const [stateOptions, setStateOptions] = useState<
    { label: string; value: string }[]
  >([])
  const [district, setDistrict] = useState([])
  const [districtOptions, setDistrictOptions] = useState<
    { label: string; value: string }[]
  >([])
  const [selectedState, setSelectedState] = useState<string>('')
  const [selectedDistrict, setSelectedDistrict] = useState<string>('')
  const [emailError, setEmailError] = useState('')
  const [isCheckBoxClicked, setIsCheckBoxClicked] = useState(false)
  const { myProfileValue } = useAmbassadorContext()

  const updateState = (state: any) => {
    setSelectedState(state)
    setDistrictOptions([])
  }

  const updateDistrict = (district: any) => {
    setSelectedDistrict(district)
  }

  const validateEmail = (value: string) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return regex.test(value)
  }

  const handleChecked = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsCheckBoxClicked(e?.target?.checked)
  }

  const getDisabled = () => {
    if (
      emailError?.length > 0 ||
      !isCheckBoxClicked ||
      selectedState?.length === 0 ||
      selectedDistrict?.length === 0 ||
      email?.trim()?.length === 0
    ) {
      return true
    }
    return false
  }

  const getVLEDetails = (type: string): string => {
    const user = JSON.parse(localStorage.getItem('user') || '{}')
    if (user) {
      if (type === 'state') return user?.profileId?.address?.state
      else if (type === 'district') return user?.profileId?.address?.district
    }
    return ''
  }

  const paymentGatewayScript = () => {
    const batchBuyUserId = localStorage.getItem('BATCH_BUY_USER_ID') || ''
    const coupanData = JSON.parse(localStorage.getItem('couponData') || '{}')
    const accessPhoneNumber =
      (localStorage.getItem('BUY_PHONE_NUMBER') as string) || ''
    let info: any = {
      batchSlug: selectedPlan?.batchId,
      cameFrom: 'batch-details',
      ambassadorDetails: {
        userId: batchBuyUserId,
        couponCode: coupanData?.couponCode,
        phoneNumber: accessPhoneNumber,
        userName: localStorage.getItem('BUY_USER_NAME') || '',
        type:
          myProfileValue?.programType === PROGRAM_TYPE.CSC_PROGRAM
            ? 'AMBASSADOR_CSC'
            : 'AMBASSADOR',
      },
    }
    if (selectedPlan?._id) {
      info.planId = selectedPlan?._id
    }
    let base64Info = btoa(JSON.stringify(info))
    window.location.href = `/sales/order-summary?info=${base64Info}`
  }

  const fetchStates = async () => {
    try {
      const params: any = {
        type: 'STATE',
      }
      const response = await Client.get(
        `${process.env.REACT_APP_PP_API_BASE_URL}/v1/student-acquisition/public/location-directory/search-v2`,
        { params: params }
      )
      if (response?.data?.data) {
        setStates(response?.data?.data)
      }
    } catch (err: any) {
      toast.error(err?.message || 'Some error occured while fetching States')
    }
  }

  const fetchDistricts = async () => {
    const preferedState: any = states.find(
      (item: any) => item.state?.trim() === selectedState?.trim()
    )
    try {
      const params: any = {
        type: 'DISTRICT',
        stateId: preferedState?.stateId,
      }
      const response = await Client.get(
        `${process.env.REACT_APP_PP_API_BASE_URL}/v1/student-acquisition/public/location-directory/search-v2`,
        { params: params }
      )
      if (response?.data?.data) {
        setDistrict(response?.data?.data)
      }
    } catch (err: any) {
      toast.error(err?.message || 'Some error occured while fetching Districts')
    }
  }

  const handleFormClick = async () => {
    const data = {
      email: email,
      address: {
        ...enteredUserData?.address,
        state: selectedState || '',
        district: selectedDistrict || '',
      },
    }
    try {
      const response = await Client.put(
        `${process.env.REACT_APP_PP_API_BASE_URL}/v1/student-acquisition/ambassador-client/${enteredUserData?._id}/update-profile`,
        data
      )
      if (response?.data?.success) {
        paymentGatewayScript()
        toast.success('User data has been successfully submitted')
      }
    } catch (err: any) {
      toast.error(err?.message || 'Some error occured while fetching Districts')
    }
  }
  const formatString = (str: string) => {
    if (!str) return ''
    return str
      .trim()
      .toLowerCase()
      .replace(/^\w/, (c) => c.toUpperCase())
  }

  const checkDefaultDistrict = (options: any) => {
    const districtName = formatString(enteredUserData?.address?.district)
    const matchedDistrict = options.find(
      (item: any) => item.value === districtName
    )
    if (matchedDistrict) {
      setSelectedDistrict(districtName)
    } 
  }

  useEffect(() => {
    if (
      enteredUserData?.address &&
      Object.keys(enteredUserData?.address)?.length > 0
    ) {
      const state = formatString(enteredUserData?.address?.state)
      setSelectedState(state)
    }
  }, [enteredUserData])

  useEffect(() => {
    if (selectedState?.length > 0 && states?.length > 0) {
      fetchDistricts()
    }
  }, [selectedState, states])

  useEffect(() => {
    if (district?.length > 0) {
      const options = district.map((item: any) => ({
        label: item.name,
        value: item.name,
      }))
      setDistrictOptions(options)
      if (
        enteredUserData?.address &&
        Object.keys(enteredUserData?.address)?.length > 0 &&
        enteredUserData?.address?.district?.length > 0
      ) {
        checkDefaultDistrict(options)
      }
    }
  }, [district])

  useEffect(() => {
    if (states?.length > 0) {
      const options = states.map((item: any) => ({
        label: item.state,
        value: item.state,
      }))
      setStateOptions(options)
    }
  }, [states])

  useEffect(() => {
    fetchStates()
  }, [])

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-[8000]" onClose={() => {}}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-50" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-8 md:translate-y-0 md:scale-95"
              enterTo="opacity-100 translate-y-0 md:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 md:scale-100"
              leaveTo="opacity-0 translate-y-8 md:translate-y-0 md:scale-95"
            >
              <Dialog.Panel className="sm:w-[480px] transform overflow-hidden sm:rounded-xl rounded-t-xl bg-white p-6 text-left align-middle shadow-xl transition-all md:flex fixed sm:bottom-auto bottom-0 w-full pointer-events-auto">
                {/* Close Button */}
                <button
                  onClick={onClose}
                  className="absolute right-5 top-5 text-gray-500 hover:text-black z-[1000] focus:outline-none"
                >
                  <XMarkIcon className="h-6 w-6" />
                </button>
                <div className="w-full">
                  <div className="flex justify-center mb-4">
                    <UserModal />
                  </div>
                  <Dialog.Title className="text-center">
                    <Typography
                      color="#1B2124"
                      variant="heading4"
                      weight="semi-bold"
                    >
                      Provide Additional Details
                    </Typography>
                  </Dialog.Title>
                  <p className="text-center mt-1 mb-6">
                    <Typography color="#3D3D3D" variant="small" weight="medium">
                      This help us complete the enrolment into the selected
                      batch
                    </Typography>
                  </p>
                  <Typography
                    className="mb-2"
                    variant="small"
                    weight="semi-bold"
                    color="#3D3D3D"
                  >
                    Student Details
                  </Typography>
                  <div className="my-4">
                    <InputField
                      placeholder="Student Email ID"
                      type="text"
                      className="w-full"
                      fullWidth={true}
                      onChange={(e) => {
                        const value = e.target.value
                        setEmail(value)

                        if (!validateEmail(value)) {
                          setEmailError('Please enter a valid email')
                        } else {
                          setEmailError('')
                        }
                      }}
                      value={email || ''}
                    />
                    {emailError && (
                      <p className="text-red-500 text-sm mt-1">{emailError}</p>
                    )}
                  </div>
                  <div className="grid grid-cols-2 gap-4 mb-6">
                    <Dropdown
                      onChange={(e) => updateState(e?.target?.value)}
                      options={stateOptions}
                      placeholder="Select State"
                      fullWidth
                      values={selectedState ? [selectedState] : []}
                      maxHeight={230}
                    />
                    <Dropdown
                      onChange={(e: any) => updateDistrict(e?.target?.value)}
                      onClick={() => {}}
                      options={districtOptions}
                      placeholder="Select District"
                      fullWidth
                      values={selectedDistrict ? [selectedDistrict] : []}
                      maxHeight={230}
                    />
                  </div>

                  {/* VLE Details */}
                  <div className="mb-4">
                    <Typography
                      variant="small"
                      weight="semi-bold"
                      color="#3D3D3D"
                    >
                      VLE Details
                    </Typography>
                  </div>

                  <div className="grid grid-cols-2 gap-4 mb-6">
                    <InputField
                      placeholder="VLE State"
                      type="text"
                      className="w-full my-4"
                      fullWidth={true}
                      disabled={true}
                      value={getVLEDetails('state')}
                    />
                    <InputField
                      placeholder="VLE District"
                      type="text"
                      className="w-full my-4"
                      fullWidth={true}
                      disabled={true}
                      value={getVLEDetails('district')}
                    />
                  </div>

                  {/* Checkbox */}
                  <label className="flex items-start gap-2 mb-6">
                    <Checkbox
                      className="mt-1"
                      variant="primary"
                      onChange={(e) => handleChecked(e)}
                    />
                    <span className="text-gray-600 text-sm">
                      I hereby declare that all the details mentioned above are
                      true to the best of my knowledge
                    </span>
                  </label>

                  {/* Proceed Button */}
                  <Button
                    variant="primary"
                    fullWidth
                    onClick={handleFormClick}
                    disabled={getDisabled()}
                  >
                    Proceed
                  </Button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
}

export default UserRegistrationModal
